import { Checkbox } from '@/components/ui/checkbox.js';
import { useToast } from '@/components/ui/hooks/use-toast.js';
import { getAdminSessions, updatePinnedSubSession } from '@/lib/api-calls.js';
import { airServerErrorFrom } from '@/lib/error-handling.js';
import { AdminSession } from '@airreading/common/data';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type CheckboxPinnedSubSessionProps = AdminSession;

export function CheckboxPinnedSubSession(props: CheckboxPinnedSubSessionProps) {
  const { id, pinnedSubSession } = props;
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { mutateAsync: updatePinned, isPending } = useMutation({ mutationFn: updatePinnedSubSession });

  const checked = !!pinnedSubSession;

  const onCheckedChange = async () => {
    try {
      await updatePinned({ sessionId: id, pinnedSubSession: !checked });
      queryClient.invalidateQueries(getAdminSessions());
      toast({ title: 'Hold session updated' });
    } catch (e: unknown) {
      toast({
        title: 'Failed to update hold session',
        description: airServerErrorFrom(e)?.userFacingMessage,
        variant: 'destructive',
      });
    }
  };

  return (
    <Checkbox checked={checked} onCheckedChange={onCheckedChange} disabled={isPending} aria-label="Hold session" />
  );
}
